import { render, staticRenderFns } from "./SingleBubble.vue?vue&type=template&id=1de5c237&scoped=true&"
import script from "./SingleBubble.vue?vue&type=script&lang=js&"
export * from "./SingleBubble.vue?vue&type=script&lang=js&"
import style0 from "./SingleBubble.vue?vue&type=style&index=0&id=1de5c237&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de5c237",
  null
  
)

export default component.exports